import { assert_true, assert_type_number } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { UTILS__number } from '@shared/utils/utils_number';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD_PRIMITIVE__base_number } from './FIELD_PRIMITIVE__base_number';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__float extends FIELD_PRIMITIVE__base_number {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_FLOAT;

  /*
   *
   */

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.FLOAT;
  }

  override set_value(value_new: number) {
    assert_type_number(value_new);

    if (this.multiple_of == 0) {
      this.value = value_new;
    } else if (UTILS__number.is_safe(value_new)) {
      this.value = value_new - (value_new % this.multiple_of);
    } else {
      this.value = value_new;
    }
  }

  override get grid2d_dimension_values(): number[] {
    assert_true(this.meta.grid2d__is_dimension);

    return this.get_value_range().to_array(this.slider_step, 2);
  }

  /*
   * METHODS
   */
}
